// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lotus-casino-provider-games {
  width: 100%;
  padding: 0 4px 24px;
  box-sizing: border-box;
}

.lotus-casino-provider-games__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 12px;
  padding: 0;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  line-height: 19px;
}

.lotus-casino-provider-games__back .icon-angle-left {
  font-size: 14px;
  line-height: 1;
}

.lotus-casino-provider-games__back:hover {
  color: #ffffff;
}

.lotus-casino-provider-games__header {
  margin-bottom: 16px;
}

.lotus-casino-provider-games__name {
  font-family: "Lato", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  line-height: 32px;
  text-transform: capitalize;
}

.lotus-casino-provider-games__counter {
  margin-top: 8px;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.65);
  line-height: 26px;
}

.lotus-casino-provider-games__subcats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.lotus-casino-provider-games__subcat {
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: #171717;
  color: rgba(255, 255, 255, 0.85);
  font-family: "Lato", sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.lotus-casino-provider-games__subcat:hover {
  border-color: rgba(103, 175, 126, 0.45);
}

.lotus-casino-provider-games__subcat.is-active {
  background: #2c4f58;
  border-color: #2c4f58;
  color: #ffffff;
}

.lotus-casino-provider-games__section-title {
  height: 42px;
  display: flex;
  align-items: center;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  text-transform: capitalize;
  padding: 0 4px;
  margin-bottom: 6px;
}

.lotus-casino-provider-games__grid {
  margin-top: 0;
}

.lotus-casino-provider-games__empty {
  grid-column: 1 / -1;
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
  padding: 32px 4px;
}

@media (max-width: 900px) {
  .lotus-casino-provider-games__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .lotus-casino-provider-games__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* Mobile slots/provider category pages — always 3 columns */
@media (max-width: 1119px) {
  .lotus-casino-provider-games {
    padding: 0 0 24px;
  }

  .lotus-casino-provider-games__grid,
  .lotus-casino-provider-games .lotus-casino-lobby-group__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 16px 8px;
    padding: 0 8px;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LotusCasinoProviderGames/LotusCasinoProviderGames.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,2DAA2D;IAC3D,aAAa;IACb,cAAc;IACd,sBAAsB;EACxB;AACF","sourcesContent":[".lotus-casino-provider-games {\n  width: 100%;\n  padding: 0 4px 24px;\n  box-sizing: border-box;\n}\n\n.lotus-casino-provider-games__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 12px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.85);\n  font-family: \"Lato\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  line-height: 19px;\n}\n\n.lotus-casino-provider-games__back .icon-angle-left {\n  font-size: 14px;\n  line-height: 1;\n}\n\n.lotus-casino-provider-games__back:hover {\n  color: #ffffff;\n}\n\n.lotus-casino-provider-games__header {\n  margin-bottom: 16px;\n}\n\n.lotus-casino-provider-games__name {\n  font-family: \"Lato\", sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 32px;\n  text-transform: capitalize;\n}\n\n.lotus-casino-provider-games__counter {\n  margin-top: 8px;\n  font-family: \"Lato\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 26px;\n}\n\n.lotus-casino-provider-games__subcats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.lotus-casino-provider-games__subcat {\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background: #171717;\n  color: rgba(255, 255, 255, 0.85);\n  font-family: \"Lato\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.lotus-casino-provider-games__subcat:hover {\n  border-color: rgba(103, 175, 126, 0.45);\n}\n\n.lotus-casino-provider-games__subcat.is-active {\n  background: #2c4f58;\n  border-color: #2c4f58;\n  color: #ffffff;\n}\n\n.lotus-casino-provider-games__section-title {\n  height: 42px;\n  display: flex;\n  align-items: center;\n  font-family: \"Lato\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  text-transform: capitalize;\n  padding: 0 4px;\n  margin-bottom: 6px;\n}\n\n.lotus-casino-provider-games__grid {\n  margin-top: 0;\n}\n\n.lotus-casino-provider-games__empty {\n  grid-column: 1 / -1;\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 14px;\n  padding: 32px 4px;\n}\n\n@media (max-width: 900px) {\n  .lotus-casino-provider-games__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 560px) {\n  .lotus-casino-provider-games__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n/* Mobile slots/provider category pages — always 3 columns */\n@media (max-width: 1119px) {\n  .lotus-casino-provider-games {\n    padding: 0 0 24px;\n  }\n\n  .lotus-casino-provider-games__grid,\n  .lotus-casino-provider-games .lotus-casino-lobby-group__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 16px 8px;\n    padding: 0 8px;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
